import './styles.css';

export default function LessonList({ lessonPlanName, sessions, onSessionSelect, selectedVideoId }) {
  return (
    <div>
      <h2>{lessonPlanName}</h2>
      <ul style={{ listStyle: 'none', padding: 0 }}>
        {sessions.map((sessionItem) => {
          const sessionName = sessionItem.training_session_video.training_session.name;
          const video = sessionItem.training_session_video.training_video;

          return (
            <li key={sessionItem.id} style={{ marginBottom: '10px' }}>
              <button
                style={{
                  backgroundColor: selectedVideoId === video.id ? '#004aad' : 'transparent',
                  color: selectedVideoId === video.id ? 'white' : '#004aad',
                  border: '1px solid #004aad',
                  padding: '8px 12px',
                  width: '100%',
                  textAlign: 'left',
                  borderRadius: '4px',
                  cursor: 'pointer'
                }}
                onClick={() => onSessionSelect(video)}
              >
                {sessionName}
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
